export default __webpack_public_path__ + "static/media/success.9d94b960.png";